import {createContext, useReducer} from 'react'

export const TuckshopContext= createContext()

export const tuckshopReducer =(state,action) =>{
    switch (action.type){
        case 'set_tuckshops':
            return { tuckshops: action.payload}
        default: 
        return state
    }
}

export const TuckshopContextProvider = ({children}) => {
const [state, dispatch] = useReducer(tuckshopReducer, {
    tuckshops: null
})

return(
    <TuckshopContext.Provider value={{...state, dispatch}}>
        {children}
    </TuckshopContext.Provider>
)
}